import { useUser } from '@paintscout/ui-business'

/**
 * True when the current session belongs to PaintScout staff rather than the account's own user —
 * a superadmin, a support user, or anyone masquerading into the account.
 *
 * One definition, because ENG-1532 grew five slightly different copies of it (the New button, the
 * sidenav, the past-due notice, the past-due banner, and SubscriptionGuard). Three included
 * `isMasquerading` and two did not, and nothing recorded whether that difference was deliberate.
 * It was not.
 *
 * Use this for "does the churned/unsubscribed block apply to this person" only. It is deliberately
 * NOT a permission check — `useUserPermissions` owns those — and it does not exempt anyone from
 * trial expiry, which is a separate state with its own copy.
 */
export function useInternalStaff(): boolean {
  const { isSuperadmin, isSupport, isMasquerading } = useUser()

  return Boolean(isSuperadmin || isSupport || isMasquerading)
}

export default useInternalStaff
